/**
 * ============================================================================
 * [P4-01] CategoryFilter - 카테고리 입력/선택 컴포넌트
 *
 * 기능:
 * - 드롭다운 + 텍스트 입력 혼합
 * - 기존 카테고리 자동완성 제안 (datalist)
 * - 새 카테고리 직접 입력 가능
 *
 * [2026-01-31] Phase 4 구현
 * ============================================================================
 */

// ============================================================================
// 1. Imports
// ============================================================================
import { useCallback, useId } from 'react'
import styles from './ScriptEditor.module.css'

// ============================================================================
// 2. Types
// ============================================================================
interface CategoryFilterProps {
  value: string
  onChange: (category: string) => void
  categories: string[]
  placeholder?: string
  disabled?: boolean
}

// ============================================================================
// 3. CategoryFilter Component
// ============================================================================
export function CategoryFilter({
  value,
  onChange,
  categories,
  placeholder = '카테고리 입력 또는 선택',
  disabled = false,
}: CategoryFilterProps) {
  // ==========================================================================
  // 3-1. 고유 ID 생성 (datalist 연결용)
  // ==========================================================================
  const listId = useId()

  // ==========================================================================
  // 3-2. 변경 핸들러
  // ==========================================================================
  const handleChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(e.target.value)
    },
    [onChange]
  )

  // ==========================================================================
  // 3-3. Render
  // ==========================================================================
  return (
    <div className={styles.categoryFilter}>
      <input
        type="text"
        list={listId}
        value={value}
        onChange={handleChange}
        placeholder={placeholder}
        disabled={disabled}
        className={styles.categoryInput}
      />
      <datalist id={listId}>
        {categories.map((cat) => (
          <option key={cat} value={cat} />
        ))}
      </datalist>
    </div>
  )
}

export default CategoryFilter
